<template>
    <main class="data-page rank-page">
        <section class="page-hero compact-hero">
            <div><small>YAXUN EXPERT RANKING</small><h1>专家排行</h1><p>以真实发布记录计算胜率、回报率、稳定性与关注热度</p></div>
            <div class="hero-kpis"><span><b>7天</b>默认统计</span><span><b>{{list.length}}</b>上榜专家</span><span><b>100%</b>数据可查</span></div>
        </section>
        <section class="data-panel">
            <div class="rank-toolbar">
                <button class="rank-ball-tab" :class="ball_val===1?'active':''" @click="setBall(1)">足球专家</button>
                <button class="rank-ball-tab" :class="ball_val===2?'active':''" @click="setBall(2)">篮球专家</button>
                <label class="rank-period-select"><span>统计周期</span><select v-model="type_val" @change="resetList" aria-label="统计周期"><option v-for="item in type_list" :key="item.value" :value="item.value">{{item.text}}</option></select></label>
            </div>
            <div class="rank-head"><span>排名 / 认证专家</span><span>周期战绩</span><span>胜率</span><span>回报率</span><span>稳定性</span><span>关注 / 专家主页</span></div>
            <div class="expert-rank-list" v-if="list.length">
                <article v-for="(c,i) in list" :key="c.user.id" class="expert-rank-card">
                    <div class="rank-card-head">
                        <em :class="i<3?'top':''">{{i+1}}</em>
                        <img :src="c.user.portrait || defimg" @error="$event.target.src=defimg" :alt="c.user.name+'头像'">
                        <div class="rank-card-person">
                            <span><router-link :to="'/member/'+c.user.id">{{c.user.name}}</router-link><i>认证专家</i></span>
                            <small>历史分析 {{c.user.recommend_count || 0}} 场</small>
                        </div>
                    </div>
                    <button v-if="c.user.relation===0" class="rank-follow" @click.stop="follow(c)">＋ 关注</button>
                    <button v-else-if="c.user.relation>0" class="rank-follow followed" @click.stop="unfollow(c)">✓ 已关注</button>
                    <span v-else class="rank-follow own-account">本人账号</span>
                    <p class="rank-card-intro">{{c.user.intro || '长期研究足球赛事基本面、阵容变化与数据走势，提供清晰审慎的赛前分析。'}}</p>
                    <div class="rank-card-stats">
                        <span><small>{{periodLabel}}命中率</small><b>{{c.sl || 0}}%</b></span>
                        <span><small>{{periodLabel}}战绩</small><b><i>{{c.sheng || 0}}</i>胜 {{c.ping || 0}}和 {{c.fu || 0}}负</b></span>
                        <span><small>热销场数</small><b>{{c.user.hot_sales || 0}} 场</b></span>
                        <span><small>关注人数</small><b>{{c.user.fans_count || 0}}</b></span>
                    </div>
                    <footer><router-link :to="'/member/'+c.user.id">查看专家主页 →</router-link></footer>
                </article>
            </div>
            <div class="panel-loading" v-else-if="init"><van-skeleton row="8" title/></div>
            <div class="empty-state" v-else><b>本周期暂无上榜专家</b><span>可切换其他统计周期</span></div>
            <button class="load-more" v-if="!finished && list.length" @click="loadMore">加载更多专家</button>
        </section>
    </main>
</template>

<script>
import defPortrait from '../assets/images/default-analyst-v3.jpg'
export default {
    name: 'rank',
    data(){ return {
        ball_val: 1, type_val: 4,
        type_list: [
            {text:'近7天',value:4},{text:'近15天',value:15},{text:'近30天',value:5},
            {text:'近7场',value:7},{text:'近15场',value:8},{text:'近30场',value:9},
            {text:'本月',value:1},{text:'上月',value:2},{text:'本周',value:12},{text:'上周',value:13}
        ],
        list: [], init: true, loading: false, finished: false, pageIndex: 1, defimg: defPortrait
    }},
    computed: {
        periodLabel(){
            const selected = this.type_list.find(item => item.value === this.type_val)
            return selected ? selected.text : '近7天'
        }
    },
    created(){ this.getList() },
    methods: {
        stabilityText(value){ return value>=90?'极高稳定':(value>=75?'表现稳定':'近期波动') },
        follow(c){ this.$post(this.$api.addfollow,{mid:c.user.id}).then(res=>{if(res.code===1){c.user.relation=res.data.relation;c.user.fans_count++;this.$toast.success(res.msg)}else this.$toast(res.msg)}) },
        unfollow(c){ this.$post(this.$api.unaddfollow,{mid:c.user.id}).then(res=>{if(res.code===1){c.user.relation=res.data.relation;c.user.fans_count=Math.max(0,c.user.fans_count-1);this.$toast.success(res.msg)}else this.$toast(res.msg)}) },
        setBall(ball){ if(this.ball_val === ball) return; this.ball_val = ball; this.resetList() },
        resetList(){ this.list=[]; this.pageIndex=1; this.finished=false; this.init=true; this.getList() },
        loadMore(){ if(this.loading || this.finished) return; this.pageIndex++; this.getList() },
        getList(){
            this.loading = true
            this.$post(this.$api.rank_list, {page:this.pageIndex, ball:this.ball_val, type:this.type_val}).then(res => {
                if(res.code === 1){
                    const rows = res.data.rank_list || []
                    rows.forEach(item => { if(item.user.portrait) item.user.portrait = this.$api.imgBaseUrl + item.user.portrait })
                    this.list = this.list.concat(rows)
                    this.finished = Boolean(res.data.end) || !rows.length
                }else this.finished = true
            }).catch(() => { this.$toast.fail('排行读取失败'); this.finished = true }).finally(() => { this.init=false; this.loading=false })
        }
    }
}
</script>

<style scoped></style>
